export enum ClipboardAction {
  CUT,
  COPY
}
